import { useState, useEffect } from "react";
import { GRID_PAGE_SIZES } from "components/common/GridComponents.jsx";
import {
  updateCurrentUserSettings,
  useCurrentUserSettings,
} from "services/userSettingsService.js";

export const VAT_RETURN_TRANSACTIONS_PAGE_SIZE_KEY = "VatReturnGridPagination";

export const useVatReturnGridPaging = () => {
  const { data: userSettings } = useCurrentUserSettings();

  const [dataState, setDataState] = useState(() => ({
    take:
      Number(
        userSettings?.find((s) => s.key === VAT_RETURN_TRANSACTIONS_PAGE_SIZE_KEY)?.value,
      ) || 50,
    skip: 0,
    pageable: { pageSizes: GRID_PAGE_SIZES },
  }));

  useEffect(() => {
    const saved = Number(
      userSettings?.find((s) => s.key === VAT_RETURN_TRANSACTIONS_PAGE_SIZE_KEY)?.value,
    );
    if (saved && saved !== dataState.take) {
      setDataState((prev) => ({ ...prev, take: saved, skip: 0 }));
    }
  }, [userSettings]);

  const handlePageChange = async (e) => {
    const newPageSize = e.page.take;
    const currentPageSize = dataState.take;
    const newSkip = newPageSize !== currentPageSize ? 0 : e.page.skip;

    if (newPageSize !== currentPageSize) {
      try {
        await updateCurrentUserSettings([
          { key: VAT_RETURN_TRANSACTIONS_PAGE_SIZE_KEY, value: newPageSize },
        ]);
      } catch (err) {
        console.error("Failed to update page size", err);
      }
    }

    setDataState((prev) => ({
      ...prev,
      skip: newSkip,
      take: newPageSize,
    }));
  };

  return { dataState, handlePageChange };
};
